import React from "react";
import { navigatAfterCloseSession } from "components/BosSessionFromUrl";
import SessionContainer from "../../components/SessionView/SessionContainer";
import SessionView from "../../components/SessionView/SessionView";

function ViewportPage(props) {

  const handleSessionClosed = (session) => {
    navigatAfterCloseSession(props.history, session);
  }

  return (
    <SessionContainer uri={props.match.params.uri} isPersistant={true} sessionClosed={handleSessionClosed} {...props}>
      <SessionView {...props} />
    </SessionContainer>
  );
}

export default (ViewportPage);
